/* PENDING CLEAN UP*/
import { apiHelper } from '@/utils/api.helper'

export const PAGE = {
  getLandingPageData,
  getArticleList,
  getArticleDetails,
  getShopData
}

const URL = {
  PAGE: 'page',
  LANDING: 'landing',
  ARTICLE_LIST: 'articlelist',
  ARTICLE_DETAILS: 'articledetails',
  SHOP: 'shop'
}

function getLandingPageData() {
  return apiHelper().get(`${URL.PAGE}/${URL.LANDING}`)
}

function getArticleList() {
  return apiHelper().get(`${URL.PAGE}/${URL.ARTICLE_LIST}`)
}

function getArticleDetails(articleId) {
  return apiHelper().get(`${URL.PAGE}/${URL.ARTICLE_DETAILS}`, { params: { article_id: articleId } })
}

function getShopData(data) {
  return apiHelper().get(`${URL.PAGE}/${URL.SHOP}`, { params: data })
}
